export default __webpack_public_path__ + "static/media/ods11.acfe66fb.svg";